import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { AppRouter } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { registerServiceWorker } from './pwa';
import './index.css';
import './styles/design-system.css';

// Hide the initial loader when React is ready
function hideLoader() {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.classList.add('hidden');
    // Remove from DOM after transition
    setTimeout(() => loader.remove(), 400);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#111923',
              border: '1px solid #ffffff20',
              color: '#edf3f6',
              borderRadius: '12px',
              boxShadow: '0 12px 36px #0005',
              fontFamily: 'Inter, sans-serif',
            },
          }}
        />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

if (import.meta.env.PROD) registerServiceWorker();

// Hide loader after a small delay to ensure first paint
requestAnimationFrame(() => {
  requestAnimationFrame(hideLoader);
});
